import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Formik, Form } from 'formik'
import { IonButton } from '@ionic/react'
import { Modal } from 'components'
import { useSubmitMessages } from 'utils'

const FIELD_ID = 'parts-order-po-number-input'

const propTypes = {
  initialPartsOrderPoNumber: PropTypes.string,
  readOnly: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
}

function PartsOrderPoNumberForm({
  initialPartsOrderPoNumber = '',
  readOnly = false,
  onSave,
}) {
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const { displaySubmitSuccess, displaySubmitFailure } = useSubmitMessages()

  if (readOnly) {
    return (
      <div className="manager-order-show__detail">
        <span className="manager-order-show__detail-label">
          Parts Order PO Number:
        </span>
        <span className="manager-order-show__detail-value">
          {initialPartsOrderPoNumber?.trim() ? initialPartsOrderPoNumber : '—'}
        </span>
      </div>
    )
  }

  return (
    <Formik
      initialValues={{
        partsOrderPoNumber: initialPartsOrderPoNumber,
      }}
      enableReinitialize
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true)
        try {
          await onSave(values.partsOrderPoNumber)
          displaySubmitSuccess('Parts order PO number saved.')
          setShowConfirmModal(false)
        } catch (error) {
          displaySubmitFailure(error?.errors, null, error)
        } finally {
          setSubmitting(false)
        }
      }}
    >
      {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        <>
          <Form className="parts-order-po-form">
            <div className="parts-order-po-form__field">
              <label className="parts-order-po-form__label" htmlFor={FIELD_ID}>
                Parts Order PO Number
              </label>
              <div className="parts-order-po-form__row">
                <input
                  id={FIELD_ID}
                  name="partsOrderPoNumber"
                  type="text"
                  className="parts-order-po-form__input"
                  value={values.partsOrderPoNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  autoComplete="off"
                />
                <IonButton
                  type="button"
                  color="tss-grey-dark"
                  className="parts-order-po-form__save-btn"
                  disabled={isSubmitting}
                  onClick={() => setShowConfirmModal(true)}
                >
                  Save
                </IonButton>
              </div>
            </div>
          </Form>

          <Modal
            isOpen={showConfirmModal}
            dismissModal={() => setShowConfirmModal(false)}
            header="Confirm save"
            fitContent
            className="accept-or-decline-modal"
          >
            <div className="accept-or-decline-modal__body">
              <p>Save this parts order PO number?</p>
            </div>
            <div className="accept-or-decline-modal__actions">
              <IonButton
                type="button"
                fill="outline"
                color="medium"
                aria-label="Cancel saving parts order PO number"
                onClick={() => setShowConfirmModal(false)}
              >
                Cancel
              </IonButton>
              <IonButton
                type="button"
                color="tss-grey-dark"
                aria-label="Confirm save parts order PO number"
                disabled={isSubmitting}
                onClick={() => handleSubmit()}
              >
                Confirm
              </IonButton>
            </div>
          </Modal>
        </>
      )}
    </Formik>
  )
}

PartsOrderPoNumberForm.propTypes = propTypes

export default PartsOrderPoNumberForm
